import { render, staticRenderFns } from "./ListPromotionRowMBRExp.vue?vue&type=template&id=ba2b4270&scoped=true"
import script from "./ListPromotionRowMBRExp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListPromotionRowMBRExp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListPromotionRowMBRExp.vue?vue&type=style&index=0&id=ba2b4270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2b4270",
  null
  
)

export default component.exports